export const events = [
    {
        start: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 15, 0, 0),
        end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 16, 0, 0),
        title: '15-16 Event',
        allDay: false,
    },
    {
        start: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 15, 0, 0),
        end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 16, 0, 0),
        title: '16-17 Event',
        allDay: false,
    },
    {
        start: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 15, 0, 0),
        end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 16, 0, 0),
        title: '16-17 Event',
        allDay: false,
    },
];

export const eventTypesIcons = {
    load: 'fas fa-truck',
    fuel: 'fas fa-gas-pump',
    call: 'fas fa-phone',
    rest: 'fas fa-bed',
    maintenance: 'fas fa-tools',
    wash: 'fas fa-soap',
    paperwork: 'fas fa-copy',
    personal: 'fas fa-user-circle',
    flag: 'fas fa-flag'
};

export const eventModel = {
    Id: 44,
    Title: 'Title Test',
    Description: 'Description Test',
    EventType: 'load',
    StartDate: '2020-06-17T15:30:00',
    EndDate: '2020-06-17T16:30:00',
    IsFlagged: false
};
